import { get, post, sess_get, sess_post } from '../utils/HttpRequests';
import * as actionTypes from './actionTypes';
const session_token = localStorage.getItem("admin-panel-sessionToken");



export const getTransactionHistory = (data) => dispatch => {
  const session_token = localStorage.getItem('admin-panel-sessionToken');
  return sess_get('admin/console/doosra-cash/transactions', session_token, data)
    .then((resp) => {
      if (resp.data.success) {

        dispatch({
          type: actionTypes.GET_DOOSRA_CASH_TRANSACTIONS_SUCCESS,
          payload: resp.data.response.list
        })
        return Promise.resolve(resp.data.response);
      } else {


      }
    })
    .catch((err) => {
      // console.log(err.response.data.error.reason);
      return Promise.reject(err.response.data.error.reason);
      dispatch({
        type: actionTypes.GET_DOOSRA_CASH_TRANSACTIONS_FAIL
      })
    })
}

export const clearTransactionHistory = () => dispatch => {
  dispatch({
    type: actionTypes.CLEAR_DOOSRA_CASH_TRANSACTIONS_LIST
  })
}

export const getTransactionDetails = (transactionId) => dispatch => {
  const session_token = localStorage.getItem('admin-panel-sessionToken');
  sess_get('admin/console/doosra-cash/transactions/details', session_token, transactionId)
    .then((resp) => {

      dispatch({
        type: actionTypes.GET_TRANSACTION_DETAILS,
        payload: resp.data.response.transactionDetails[0]
      })
    })
    .catch((err) => {
      // console.log('err', err.response.data.error)
      dispatch({
        type: actionTypes.GET_DOOSRA_CASH_TRANSACTIONS_FAIL
      })
    })
}

export const clearTransactionDetails = () => dispatch => {
  dispatch({
    type: actionTypes.CLEAR_TRANSACTION_DETAILS
  })
}